import React, { useEffect, useState } from 'react';
import { Table, Tag } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { format } from 'date-fns';
import srLocale from 'date-fns/locale/sr';
import { Dashboard } from '../../../../../models/Dashboard/Dashboard';
import { UpcomingEvent } from '../../../../../models/Dashboard/contracts';

const eventTypeMap = {
  pickup: { label: 'Preuzimanje', color: 'blue' },
  return: { label: 'Vraćanje', color: 'gold' }
};

const columns: ColumnsType<UpcomingEvent> = [
  {
    title: 'Datum',
    dataIndex: 'event_date',
    key: 'event_date',
    render: (date: string) => format(new Date(date), 'dd.MM.yyyy. HH:mm', { locale: srLocale })
  },
  {
    title: 'Tip događaja',
    dataIndex: 'event_type',
    key: 'event_type',
    render: (type: 'pickup' | 'return') => (
      <Tag color={eventTypeMap[type].color}>{eventTypeMap[type].label}</Tag>
    )
  },
  {
    title: 'Klijent',
    dataIndex: 'customer_name',
    key: 'customer_name'
  },
  {
    title: 'Broj narudžbine',
    dataIndex: 'order_number',
    key: 'order_number',
    render: (number: number, record: UpcomingEvent) => (
      <a href={`/admin/orders/${record.order_id}`} target="_blank" rel="noopener noreferrer">
        {number}
      </a>
    )
  }
];

const UpcomingEventsTable: React.FC = () => {
  const [data, setData] = useState<UpcomingEvent[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    Dashboard.getUpcomingEvents()
      .then((events) => setData(events))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div style={{ marginBottom: 32 }}>
      <h3 style={{ color: '#e9e9e9', marginBottom: 16,marginTop: 16  }}>Tabela Preuzimanja i Vraćanja</h3>
      <Table
        columns={columns}
        dataSource={data}
        rowKey={(row) => `${row.event_type}-${row.order_id}-${row.event_date}`}
        loading={loading}
        className="cs-table-wrapper"
        pagination={{ pageSize: 10 }}
      />
    </div>
  );
};

export default UpcomingEventsTable; 